export const getFleetTooltipLabel = ({ fdFleet }) => {
  switch (fdFleet) {
    case 'N':
      return 'Non-Fleet';
    case null:
      return 'Non-Fleet';
    case 'C':
      return 'Corporate Fleet';
    case 'D':
      return 'Daily Rental Fleet';
    default:
      return null;
  }
};
